enum FileSourceSize {
    Original = 0,
    Tiny = 1,
    Normal = 2,
    Banner = 3
}

export default FileSourceSize
